export default __webpack_public_path__ + "static/media/slot-img.1c4e1a9e.webp";